import { Box, Chip, Divider } from '@mui/material';
import React from 'react';
/**
 * Renders a list of filter chips based on the applied filter values and corresponding labels.
 *
 * @param {FilterChipsProps} root0 - The props object.
 * @param {FilterValue} root0.valueApplied - The current applied filter values.
 * @param {Record<string, string[]>} root0.chipLabelsApplied - A mapping of filter keys to their displayable chip labels.
 * @returns {JSX.Element | null} A list of chips and a divider, or `null` if no chips are to be rendered.
 */
export const FilterChips = ({ valueApplied, chipLabelsApplied }) => {
    let chipLabelsToRender = [];
    Object.keys(valueApplied.value).forEach((key) => {
        if (chipLabelsApplied[key]) {
            chipLabelsToRender = [...chipLabelsToRender, ...chipLabelsApplied[key]];
        }
    });
    if (chipLabelsToRender.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: { display: 'flex', flexWrap: 'wrap', px: 2, pt: 1, pb: 2, gap: 1 }, "data-test": 'filter-chips' }, chipLabelsToRender.map((chipLabel, index) => {
            return React.createElement(Chip, { key: index, label: chipLabel, "data-test": `chip-${index}` });
        })),
        React.createElement(Divider, null)));
};
